import React from "react"
import Chart from "chart.js/auto"

class Dashboard extends React.Component {
    constructor(props){
        super(props);
        const offset = (new Date()).getTimezoneOffset()
        const original_days = 7;
        this.state = {
            time_start: new Date(new Date() - (offset*60000) - original_days*86400000).toISOString().split('T')[0],
            time_end: new Date(new Date() - (offset*60000)).toISOString().split('T')[0],
            offset: offset,
            offset_iso: String(new Date()).split('GMT')[1].slice(0,5),
            currency: 'aud',
            days: original_days,
            day_data: {},
            usd_conversions: {
                aud: 1.38,
                usd: 1
            }
        };

        this.retrieve_payments = this.retrieve_payments.bind(this);
        this.set_chart_canvas = this.set_chart_canvas.bind(this);

    }

    componentDidMount(){
        this.retrieve_payments();
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.day_data !== this.state.day_data){
            this.draw_chart();
        }
    }

    componentWillUnmount(){
        if (this.chart){
            this.chart.destroy();
        }
    }

    set_chart_canvas(canvas){
        this.chart_canvas = canvas;
        this.draw_chart();
    }

    draw_chart(){
        const entries = Object.entries(this.state.day_data || {}).sort(([firstDate], [secondDate]) => firstDate.localeCompare(secondDate));
        if (!this.chart_canvas || entries.length === 0){
            return;
        }

        if (this.chart){
            this.chart.destroy();
        }

        this.chart = new Chart(this.chart_canvas, {
            type: 'line',
            data: {
                labels: entries.map(([date]) => this.format_date(date)),
                datasets: [{
                    label: 'Revenue',
                    data: entries.map(([, amount]) => amount),
                    borderColor: '#4f46e5',
                    backgroundColor: 'rgba(79, 70, 229, 0.12)',
                    borderWidth: 2,
                    pointBackgroundColor: '#4f46e5',
                    pointHoverRadius: 5,
                    pointRadius: 3,
                    fill: true,
                    tension: 0.25
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => `Revenue: ${this.format_currency(context.parsed.y)}`
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 7,
                            maxRotation: 0
                        },
                        title: {
                            display: true,
                            text: 'Date'
                        }
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            callback: (amount) => this.format_currency(amount)
                        },
                        title: {
                            display: true,
                            text: 'Revenue'
                        }
                    }
                }
            }
        });
    }

    format_currency(amount){
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: this.state.currency.toUpperCase()
        }).format(amount / 100);
    }

    format_date(date){
        return new Intl.DateTimeFormat('en-AU', {
            day: 'numeric',
            month: 'short'
        }).format(new Date(`${date}T00:00:00`));
    }

    retrieve_payments(){
        let offset = 0, limit = 100;
        console.log(`/payments?q[workspace_id_eq]=${this.props.workspace_id}&q[succeeded_at_gteq]=${this.state.time_start+"T00:00:00"+this.state.offset_iso}&q[succeeded_at_lteq]=${this.state.time_end+"T23:59:59"+this.state.offset_iso}&offset=${offset}&limit=${limit}`);
        fetch(`/payments?q[workspace_id_eq]=${this.props.workspace_id}&q[succeeded_at_gteq]=${this.state.time_start+"T00:00:00"+this.state.offset_iso}&q[succeeded_at_lteq]=${this.state.time_end+"T23:59:59"+this.state.offset_iso}&offset=${offset}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.json()).then((json) => {
            if (!json.payments){
                return console.log('failed'); //Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
            }
            console.log(json);
            this.setState({
                payments: json.payments
            });
            let pre_data = json.payments.map((p) => {return {
                x: new Date(new Date(p.succeeded_at) - this.state.offset*60000).toISOString().split('T')[0],
                y: Math.round(this.state.usd_conversions[this.state.currency] * p.amount / this.state.usd_conversions[p.currency])
            };});
            new Date(this.state.time_start)
            let data = {};
            const dates = Array(this.state.days).fill(null).map((x,i) => {
                const date = new Date(this.state.time_start)
                return new Date(date.setDate(date.getDate() + i));
            }).map((d) => d.toISOString().split('T')[0]);
            console.log(dates);
            dates.forEach((d) => data[d] = 0);
            pre_data.forEach(
                (datum) => {
                    if (!data[datum.x]){
                        data[datum.x] = datum.y;
                    } else {
                        data[datum.x] = data[datum.x] + datum.y;
                    }
                }
            );
            console.log(data);
            this.setState({
                day_data: data
            });
        })
    }

    render(){
        const has_data = Object.keys(this.state.day_data || {}).length > 0;

        return (
            <section className="dashboard-chart-card" aria-labelledby="dashboard-revenue-title">
                <div className="dashboard-chart-heading">
                    <div>
                        <p className="dashboard-chart-eyebrow">Last {this.state.days} days</p>
                        <h1 id="dashboard-revenue-title">Daily revenue</h1>
                    </div>
                    <span className="dashboard-chart-currency">{this.state.currency.toUpperCase()}</span>
                </div>
                <div className="dashboard-chart-container">
                    {!has_data && <p className="dashboard-chart-loading">Loading revenue data…</p>}
                    <canvas
                        ref={this.set_chart_canvas}
                        className={has_data ? '' : 'dashboard-chart-hidden'}
                        role="img"
                        aria-label={`Daily revenue line chart in ${this.state.currency.toUpperCase()}`}
                    />
                </div>
            </section>
        );
    }
}

export default Dashboard;
